module.exports = __webpack_public_path__ + "assets/img/pl.6607e08c.svg";